import { useFlags, useLDClient } from 'gatsby-plugin-launchdarkly'
import React, { createContext, useContext, useEffect } from 'react'

import { useUser } from './UserContext'

const FeatureFlagContext = createContext({
  LDFlags: null,
})

export const useFeatureFlags = () => useContext(FeatureFlagContext)

export const FeatureFlagProvider = ({ children }) => {
  const LDFlags = useFlags()
  const ldClient = useLDClient()
  const { user } = useUser()

  useEffect(() => {
    const product = process.env.PRODUCT === 'clair' ? 'Clair' : 'OnLabel'
    if (ldClient && user) {
      ldClient.identify({
        kind: 'user',
        key: user.pk,
        email: user.email,
        username: user.username,
        firstName: user.first_name,
        lastName: user.last_name,
        plan: user.plan,
        isTrial: user.is_trial,
        studentStatus: user.student_status,
        platform: product,
        anonymous: false,
      })
    } else if (ldClient) {
      ldClient.identify({
        kind: 'user',
        anonymous: true,
        platform: product,
      })
    }
  }, [ldClient, user])

  return (
    <FeatureFlagContext.Provider value={{ LDFlags }}>
      {children}
    </FeatureFlagContext.Provider>
  )
}
